import { Component, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";

@Component({
  selector: "app-vertical",
  templateUrl: "./vertical.component.html",
  styleUrls: ["./vertical.component.scss"],
})
export class VerticalComponent implements OnInit {
  // @HostListener("window:scroll", [])
  // onWindowScroll() {
  //   const botIcon = document.getElementById("botIcon");
  //   const scrollY = window.scrollY;
  //   const viewportHeight = window.innerHeight;
  //   const offset = 35;

  //   botIcon.style.top = `${
  //     scrollY + viewportHeight - botIcon.offsetHeight - offset
  //   }px`;
  // }
  isFlipping = true;
  @HostListener("window:scroll", [])
onWindowScroll() {
  const botIcon = document.getElementById("botIcon");
  if (botIcon) {
    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;
    const offset = 35;

    botIcon.style.top = `${
      scrollY + viewportHeight - botIcon.offsetHeight - offset
    }px`;
  }
}

  private _message$ = new Subject<string>();
  successMessage = "";
 get isChatBotPage(): boolean {
    return this.router.url.includes('/chatbot'); // adjust the path as needed
  }
  user:any;
  custId:string='';

  constructor(private router: Router) {
    this.user = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
    if(this.user['role']!=='SUPERADMIN'){
      this.custId = this.user?.['user']?.['custId']
    }
    
  }

  ngOnInit(): void {
    document.body.setAttribute("data-sidebar", "dark");
    document.body.removeAttribute("data-layout-size");
    document.body.removeAttribute("data-layout");
    document.body.removeAttribute("data-topbar");
    document.body.classList.remove("auth-body-bg");
    document.body.classList.add("sidebar-enable");
    document.body.classList.add("vertical-collpsed");
  }
  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    document.body.classList.toggle("sidebar-enable");
    document.body.classList.toggle("vertical-collpsed");

    if (window.screen.width <= 768) {
      document.body.classList.remove("vertical-collpsed");
    }
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle("right-bar-enabled");
  }
  getChatBot() {
    this.router.navigate(["/chatbotComponent"]);
  }
}
